import { drawArrow2, drawHammer2 } from "./whiteboard_util";
const SIZE_MAP = [2, 4, 6];
const DRAGGER_STROKE_WIDTH = 10;
const HITBOX_STROKE_WIDTH = 18;
export function CNPenFactory(data) {
    switch (data.t) {
        case "pen":
            return new Pen(data);
        case "penTab":
            return new PenTab(data);
        case "penArrow":
            return new PenArrow(data);
        case "penDotted":
            return new PenDotted(data);
        case "penDottedArrow":
            return new PenDottedArrow(data);
    }
}

class CNFreePen {
    constructor(data) {
        this.name = data.t;
        this.color = data.c;
        this.size = data.th;
        this.points = data.d;
        this.data = data;
        this.removerImage = data.removerImage;
        this.id = this.name + "" + data.drawId;
        this.drawId = data.drawId;
        this.version = data.v;
        this.visible = data.visible || true;

        this.remover = this.buildRemover();
        this.dragger = this.buildDragger();
        this.hitbox = this.buildHitbox();
    }

    pasteData(inc) {
        return this.points.map((p) => {
            return p + 30 * inc;
        });
    }

    setClickAction(callback) {
        this.element.on("click", () => callback(this.color));
        this.element.on("tap", () => callback(this.color));
    }

    setColor(color) {
        this.color = color;
        this.lineElement.stroke(color);
    }

    getBoundingBox() {
        const xs = this.points.filter((_, i) => i % 2 === 0);
        const ys = this.points.filter((_, i) => i % 2 !== 0);

        const minX = Math.min(...xs);
        const maxX = Math.max(...xs);
        const minY = Math.min(...ys);
        const maxY = Math.max(...ys);

        const width = maxX - minX;
        const height = maxY - minY;

        return { minX, maxX, minY, maxY, width, height };
    }

    buildDragger() {
        const dragger = new Konva.Line({
            points: this.points,
            stroke: "rgba(14, 140, 233, 0.5)",
            strokeWidth: 0,
            dash: [6, 4],
            lineCap: "round",
            lineJoin: "round",
            name: "dragger",
            visible: true,
        });

        return dragger;
    }

    buildHitbox() {
        return this.dragger.clone({
            name: "hitbox",
            stroke: "rgba(0, 0, 0, 0.01)",
            strokeWidth: HITBOX_STROKE_WIDTH,
            dash: [],
            visible: true,
        });
    }

    setDragStart(callback) {
        const _this = this;
        this.element.on("dragstart", (e) => {
            callback(e);
            _this.dragger.strokeWidth(DRAGGER_STROKE_WIDTH);
        });
    }

    setDragEnd(callback) {
        this.element.on("dragend", (e) => callback(e));
    }

    setDragClick(callback) {
        const _this = this;
        this.element.on("click", (e) => {
            callback(e);
            _this.dragger.strokeWidth(DRAGGER_STROKE_WIDTH);
        });
        this.element.on("tap", (e) => {
            callback(e);
            _this.dragger.strokeWidth(DRAGGER_STROKE_WIDTH);
        });
    }

    buildRemover() {
        const remover = new Konva.Image({
            image: this.removerImage,
            width: 20,
            height: 20,
            name: "remover",
            x: this.data.d[0] + 10,
            y: this.data.d[1] + 10,
            visible: false,
        });
        remover.on("mouseover", () => {
            document.body.style.cursor = "pointer";
        });
        remover.on("mouseout", () => {
            document.body.style.cursor = "default";
        });

        return remover;
    }

    updateRemover() {
        this.remover.x(this.points[this.points.length - 2] + 10);
        this.remover.y(this.points[this.points.length - 1] + 10);
    }

    setRemoverAction(callback) {
        this.removeAction = callback;
        this.remover.on("click", () => {
            callback();
        });
        this.remover.on("tap", () => {
            callback();
        });
    }
    getPoints() {
        return this.points;
    }

    addPoints(points) {
        if (this.points) {
            this.points = this.points.concat(points);
        } else {
            this.points = points;
        }
        if (this.lineElement) {
            this.lineElement?.points(this.points);
        }
        this.updateDragger();
        this.updateRemover();
    }

    updateDragger() {
        this.dragger.points(this.points);
        this.hitbox.points(this.points);
    }

    updateHitbox() {
        this.hitbox.points(this.points);
    }
}

export class Pen extends CNFreePen {
    constructor(data) {
        super(data);

        this.element = this.buildElement();
    }

    buildElement() {
        this.lineElement = new Konva.Line({
            stroke: this.color,
            strokeWidth: SIZE_MAP[this.size],
            points: this.points,
            lineCap: "round",
            lineJoin: "round",
            name: this.name,
        });

        const group = new Konva.Group({
            draggable: true,
            id: this.id,
            visible: this.visible,
        });
        group.add(this.lineElement);
        group.add(this.remover);
        group.add(this.dragger);
        group.add(this.hitbox);
        group.setAttrs({
            instance: this,
        });

        return group;
    }
}

export class PenDotted extends CNFreePen {
    constructor(data) {
        super(data);

        this.element = this.buildElement();
    }

    buildElement() {
        this.lineElement = new Konva.Line({
            stroke: this.color,
            strokeWidth: SIZE_MAP[this.size],
            points: this.points,
            lineCap: "round",
            lineJoin: "round",
            name: this.name,
            dash: this.version == 2 ? [10, 10] : [5, 20],
        });

        const group = new Konva.Group({
            draggable: true,
            id: this.id,
            visible: this.visible,
        });
        group.add(this.lineElement);
        group.add(this.remover);
        group.add(this.dragger);
        group.add(this.hitbox);
        group.setAttrs({
            instance: this,
        });

        return group;
    }
}

export class PenTab extends CNFreePen {
    constructor(data) {
        super(data);

        this.element = this.buildElement();
    }

    setColor(color) {
        this.color = color;
        this.lineElementShape.stroke(color);
    }

    buildElement() {
        const _this = this;
        this.lineElementShape = new Konva.Shape({
            stroke: this.color,
            strokeWidth: SIZE_MAP[this.size],
            points: this.points,
            lineCap: "square",
            name: this.name,
            sceneFunc: function (ctx, shape) {
                ctx.beginPath();
                ctx.moveTo(_this.points[0], _this.points[1]);
                for (var i = 2; i < _this.points.length; i += 2) {
                    ctx.lineTo(_this.points[i], _this.points[i + 1]);
                }
                ctx.fillStrokeShape(shape);
                drawHammer2(ctx, _this.points, _this.color, _this.size);
                ctx.fillStrokeShape(shape);
            },
        });

        const group = new Konva.Group({
            draggable: true,
            id: this.id,
            visible: this.visible,
        });
        group.add(this.lineElementShape);
        group.add(this.remover);
        group.add(this.dragger);
        group.add(this.hitbox);
        group.setAttrs({
            instance: this,
        });

        return group;
    }
}

export class PenArrow extends CNFreePen {
    constructor(data) {
        super(data);

        this.element = this.buildElement();
    }

    setColor(color) {
        this.color = color;
        this.lineElementShape.stroke(color);
    }

    buildElement() {
        const _this = this;
        this.lineElementShape = new Konva.Shape({
            stroke: this.color,
            strokeWidth: SIZE_MAP[this.size],
            points: this.points,
            lineCap: "square",
            name: this.name,
            sceneFunc: function (ctx, shape) {
                ctx.beginPath();
                ctx.moveTo(_this.points[0], _this.points[1]);
                for (var i = 2; i < _this.points.length; i += 2) {
                    ctx.lineTo(_this.points[i], _this.points[i + 1]);
                }
                ctx.fillStrokeShape(shape);
                drawArrow2(ctx, _this.points, _this.color, _this.size);
                ctx.fillStrokeShape(shape);
            },
        });

        const group = new Konva.Group({
            draggable: true,
            id: this.id,
            visible: this.visible,
        });
        group.add(this.lineElementShape);
        group.add(this.remover);
        group.add(this.dragger);
        group.add(this.hitbox);
        group.setAttrs({
            instance: this,
        });

        return group;
    }
}

export class PenDottedArrow extends CNFreePen {
    constructor(data) {
        super(data);

        this.element = this.buildElement();
    }

    setColor(color) {
        this.color = color;
        this.lineElementShape.stroke(color);
    }

    buildElement() {
        const _this = this;
        this.lineElementShape = new Konva.Shape({
            stroke: this.color,
            strokeWidth: SIZE_MAP[this.size],
            points: this.points,
            lineCap: "square",
            name: this.name,
            dash: this.version == 2 ? [10, 10] : [5, 20],
            sceneFunc: function (ctx, shape) {
                ctx.beginPath();
                ctx.moveTo(_this.points[0], _this.points[1]);
                for (var i = 2; i < _this.points.length; i += 2) {
                    ctx.lineTo(_this.points[i], _this.points[i + 1]);
                }
                ctx.fillStrokeShape(shape);
                drawArrow2(ctx, _this.points, _this.color, _this.size);
                ctx.fillStrokeShape(shape);
            },
        });

        const group = new Konva.Group({
            draggable: true,
            visible: this.visible,
            id: this.id,
        });
        group.add(this.lineElementShape);
        group.add(this.remover);
        group.add(this.dragger);
        group.add(this.hitbox);
        group.setAttrs({
            instance: this,
        });

        return group;
    }
}
